import { getNetworkMethods } from './network'
import drupalApi from '@futures-platform/connectors/drupal-api'
import * as actionTypes from '@futures-platform/reducers/actionTypes'
import { requestTranslation } from '@futures-platform/i18n'

export const getPhenomenaTypes = groupId => (dispatch, getState) => {
    const { loading, success, error } = getNetworkMethods(
        actionTypes.GET_PHENOMENA_TYPES,
        actionTypes.GET_PHENOMENA_TYPES_SUCCESS,
        requestTranslation('fetchingPhenomenaTypesError')
    )

    dispatch(loading())

    return drupalApi.getPhenomenaTypes(groupId)
        .then(data => dispatch(success(data)))
        .catch(err => dispatch(error(err)))
}
